import axios, { AxiosError, AxiosResponse } from 'axios'
import { BASE_API_URL, CHECK_TOKEN_ENDPOINT } from './api'

export const checkTokenValidity = (token: string) => {
  return axios
    .post(`${BASE_API_URL}${CHECK_TOKEN_ENDPOINT}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
      if (error.response) return error.response.data
      return error
    })
}
